import React from 'react';
import ControlPanel from '../common/ControlPanel';

const controls = [
  { key: 'remote_switch', label: 'Remote Switch', type: 'select', reg: 514, options: [
    { value: 1, label: 'ON' },
    { value: 2, label: 'OFF' },
  ]},
  { key: 'cooling_sp', label: 'Cooling Setpoint', type: 'number', reg: 10, min: 0, max: 50, step: 0.1, unit: '°C', scale: 10 },
  { key: 'dew_point_dehumid_sp', label: 'Dew Point Dehumid SP', type: 'number', reg: 11, min: -40, max: 120, step: 0.1, unit: '°C', scale: 10 },
  { key: 'cooling_sensitivity', label: 'Cooling Sensitivity', type: 'number', reg: 12, min: 1, max: 10, step: 0.1, unit: '°C', scale: 10 },
  { key: 'dew_point_dehumid_sensitivity', label: 'Dew Point Sensitivity', type: 'number', reg: 13, min: 1, max: 20, step: 0.1, unit: '°C', scale: 10 },
  { key: 'high_temp_alarm_sp', label: 'High Temp Alarm', type: 'number', reg: 14, min: 5, max: 80, step: 0.1, unit: '°C', scale: 10 },
  { key: 'low_temp_alarm_sp', label: 'Low Temp Alarm', type: 'number', reg: 16, min: -40, max: 5, step: 0.1, unit: '°C', scale: 10 },
  { key: 'high_humidity_alarm_sp', label: 'High Humidity Alarm', type: 'number', reg: 17, min: 40, max: 100, step: 0.1, unit: '%RH', scale: 10 },
  { key: 'dehumid_fan_stop_sp', label: 'Fan Stop Setpoint', type: 'number', reg: 19, min: -20, max: 50, step: 0.1, unit: '°C', scale: 10 },
  { key: 'relative_dehumid_sp', label: 'Humidity Setpoint', type: 'number', reg: 21, min: 40, max: 80, step: 1, unit: '%', scale: 1 },
  { key: 'relative_dehumid_sensitivity', label: 'Humidity Sensitivity', type: 'number', reg: 23, min: 1, max: 20, step: 1, unit: '%', scale: 1 },
  { key: 'humidity_calc_method', label: 'Calc Method', type: 'select', reg: 25, options: [
    { value: 1, label: 'Relative Humidity' },
    { value: 2, label: 'Dew Point Temp' },
    { value: 3, label: 'Monitor Humidity' },
  ]},
  { key: 'dew_point_data_source', label: 'Dew Point Data Source', type: 'select', reg: 27, options: [
    { value: 1, label: 'Local temp & humidity' },
    { value: 2, label: 'Monitor temp & humidity' },
  ]},
  { key: 'monitor_temp_release', label: 'Monitor Temp Release', type: 'number', reg: 523, min: -40, max: 120, step: 0.1, unit: '°C', scale: 10 },
  { key: 'monitor_humidity_release', label: 'Monitor Humidity Release', type: 'number', reg: 524, min: 0, max: 100, step: 1, unit: '%', scale: 1 },
  { key: 'heating_point', label: 'Heating Point', type: 'number', reg: 525, min: 0, max: 18, step: 0.1, unit: '°C', scale: 10 },
  { key: 'heater_sensitivity', label: 'Heater Sensitivity', type: 'number', reg: 526, min: 0, max: 10, step: 0.1, unit: '°C', scale: 10 },
];

// dehumidifier1 = addr 3, dehumidifier2 = addr 4
const addrMap = { dehumidifier1: '3', dehumidifier2: '4' };

function buildDesired(values, dehumidifier) {
  const addr = addrMap[dehumidifier];
  const desired = { dehumidifier: { [addr]: { cmd: {} } } };
  for (const [key, value] of Object.entries(values)) {
    const ctrl = controls.find(c => c.key === key);
    if (!ctrl) continue;
    const scaledValue = ctrl.scale ? Math.round(value * ctrl.scale) : value;
    desired.dehumidifier[addr].cmd[key] = { reg: ctrl.reg, value: scaledValue };
  }
  return desired;
}

export default function DehumidifierControlPanel({ dehumidifier = 'dehumidifier1' }) {
  return (
    <ControlPanel
      title={`${dehumidifier.replace('dehumidifier', 'Dehum ')} Controls (addr ${addrMap[dehumidifier]})`}
      controls={controls}
      buildDesired={(values) => buildDesired(values, dehumidifier)}
    />
  );
}
